import { labels } from 'constants/labels';

type ModeratorPanelLabels = (typeof labels)['moderatorPanelTabs'][keyof (typeof labels)['moderatorPanelTabs']];
type FlaggedViewLabels = (typeof labels)['flaggedViewTabs'][keyof (typeof labels)['flaggedViewTabs']];
type DeletedViewLabels = (typeof labels)['deletedViewTabs'][keyof (typeof labels)['deletedViewTabs']];

export interface TabsState {
  moderatorPanel: ModeratorPanelLabels;
  flaggedView: FlaggedViewLabels;
  deletedView: DeletedViewLabels;
}

export const initialState: TabsState = {
  moderatorPanel: labels.moderatorPanelTabs.HOME,
  flaggedView: labels.flaggedViewTabs.POSTS,
  deletedView: labels.deletedViewTabs.POSTS,
};
